// @flow
import { LOCATION_CHANGE } from "connected-react-router";
import {
  AuthenticateSuccess,
  AuthenticateError,
  ToggleTermsOfUseModal,
  SetPassword,
  SetPasswordSuccess,
  SetPasswordError,
  SetAccessTokenExpiresAt,
  Impersonate,
  ImpersonateSuccess,
  ImpersonateError,
  ToggleContactModal,
} from "../constants/actions";
import type { Profile } from "../types";
import { cloneObject } from "@utils/object";

export type LoginState = $Exact<{
  authChecked: boolean,
  loggedIn: boolean,
  isLoading: boolean,
  profile: Profile | null,
  error: string | null,
  showMailSent: boolean,
  impersonateLogin: boolean,
  modals: $Exact<{
    termsOfUse: $Exact<{
      visible: boolean,
    }>,
    contact: $Exact<{
      visible: boolean,
    }>,
  }>,
}>;

export const initialState: LoginState = {
  authChecked: false,
  loggedIn: false,
  isLoading: false,
  profile: null,
  error: null,
  showMailSent: false,
  impersonateLogin: false,
  modals: {
    termsOfUse: {
      visible: false,
    },
    contact: {
      visible: false,
    },
  },
};

const onLocationChange = (state: LoginState) => () => {
  return { ...state, isLoading: false, error: null };
};

const onAuthenticationSuccess = (state: LoginState) => ({ payload }: Object) => {
  return {
    ...state,
    authChecked: true,
    loggedIn: true,
    error: null,
    isLoading: false,
    profile: payload,
  };
};

const onAuthenticationError = (state: LoginState) => () => {
  return {
    ...state,
    authChecked: true,
    profile: null,
    error: null,
    loggedIn: false,
    isLoading: false,
  };
};

export const onToggleTermsOfUseModal = (state: LoginState) => ({ payload }: Object) => {
  return {
    ...state,
    modals: {
      ...state.modals,
      termsOfUse: {
        ...state.modals.termsOfUse,
        visible: payload,
      },
    },
  };
};

export const onSetPassword = (state: LoginState): (() => LoginState) => () => {
  return { ...state, isLoading: true };
};

export const onSetPasswordSuccess = (state: LoginState) => () => {
  return { ...state, isLoading: false, error: null };
};

export const onSetPasswordError = (state: LoginState) => ({ payload }: Object) => {
  return { ...state, isLoading: false, error: payload };
};

export const onImpersonate = (state: LoginState): (() => LoginState) => () => {
  return { ...state, isLoading: true };
};

export const onImpersonateSuccess = (state: LoginState) => () => {
  return {
    ...state,
    isLoading: false,
    error: null,
    impersonateLogin: true,
  };
};

export const onImpersonateError = (state: LoginState) => ({ payload }: Object) => {
  return { ...state, isLoading: false, error: payload };
};

export const onSetAccessTokenExpiresAt = (state: LoginState) => ({ payload }: Object) => {
  return {
    ...state,
    profile: {
      ...state.profile,
      accessTokenExpiresAt: payload,
    },
  };
};

export const onToggleContactModal = (state: LoginState) => () => ({
  ...state,
  modals: {
    ...state.modals,
    contact: {
      visible: !state.modals.contact.visible,
    },
  },
});

export default (state: LoginState = initialState, action: Object) => {
  const act = {
    [AuthenticateSuccess]: onAuthenticationSuccess,
    [AuthenticateError]: onAuthenticationError,
    [ToggleTermsOfUseModal]: onToggleTermsOfUseModal,
    [SetPassword]: onSetPassword,
    [SetPasswordSuccess]: onSetPasswordSuccess,
    [SetPasswordError]: onSetPasswordError,
    [SetAccessTokenExpiresAt]: onSetAccessTokenExpiresAt,
    [Impersonate]: onImpersonate,
    [ImpersonateSuccess]: onImpersonateSuccess,
    [ImpersonateError]: onImpersonateError,
    [ToggleContactModal]: onToggleContactModal,
    [LOCATION_CHANGE]: onLocationChange,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
